import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
    BLOG_ROUTE,
    ABOUT_US_ROUTE,
    PLACES_ROUTE,
    PHOTO_GALLERY_ROUTE
} from '../../../../utils/consts';
import styles from './ExploreMenu.module.css';
import { reachGoal } from "../../../../utils/metrika/metrika";

const MENU_ITEMS = [
    {
        title: 'Интересные места',
        subtitle: 'Где погулять и что посмотреть',
        route: PLACES_ROUTE,
        goal: 'history.push(PLACES_ROUTE) NAVIGATION'
    },
    {
        title: 'Фотогалерея',
        subtitle: 'Живые фото города',
        route: PHOTO_GALLERY_ROUTE,
        goal: 'history.push(PHOTO_GALLERY_ROUTE) NAVIGATION'
    },
    {
        title: 'Блог',
        subtitle: 'Полезные статьи и советы',
        route: BLOG_ROUTE,
        goal: 'history.push(BLOG_ROUTE) NAVIGATION'
    },
    {
        title: 'О нас',
        subtitle: 'Кто мы и как работаем',
        route: ABOUT_US_ROUTE,
        goal: 'history.push(ABOUT_US_ROUTE) NAVIGATION'
    }
];

const ExploreMenu = ({ show, onClose }) => {
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (!show) {
            document.body.style.overflow = '';
            return;
        }

        document.body.style.overflow = 'hidden';

        const handleEsc = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleEsc);

        return () => {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', handleEsc);
        };
    }, [show, onClose]);

    const handleNavigate = (route, goal) => {
        history.push(route);
        onClose();
        reachGoal(goal);
    };

    const isActiveRoute = (route) => location.pathname === route;

    return (
        <div
            className={`${styles.overlay} ${show ? styles.overlayActive : ''}`}
            aria-hidden={!show}
        >
            <div
                className={styles.backdrop}
                onClick={onClose}
            />

            <aside
                className={styles.panel}
                role="dialog"
                aria-modal="true"
                aria-label="Меню разделов"
            >
                <div className={styles.header}>
                    <div className={styles.headerText}>
                        <div className={styles.eyebrow}>Навигация</div>
                        <div className={styles.title}>Разделы Arento</div>
                    </div>

                    <button
                        type="button"
                        className={styles.closeButton}
                        onClick={onClose}
                        aria-label="Закрыть меню"
                    >
                        <span />
                        <span />
                    </button>
                </div>

                <nav className={styles.nav}>
                    {MENU_ITEMS.map((item) => {
                        const isActive = isActiveRoute(item.route);

                        return (
                            <button
                                key={item.route}
                                type="button"
                                className={`${styles.menuItem} ${isActive ? styles.menuItemActive : ''}`}
                                onClick={() => handleNavigate(item.route, item.goal)}
                            >
                                <span className={styles.menuItemMain}>
                                    {item.title}
                                </span>
                                <span className={styles.menuItemSub}>
                                    {item.subtitle}
                                </span>
                            </button>
                        );
                    })}
                </nav>
            </aside>
        </div>
    );
};

export default ExploreMenu;